<div class="oiq-notification-event-list">
  @for (row of items; track row.smsMessageId) {
    <div class="item border-dark-50 rounded border shadow">
      <span class="material-symbols-outlined">sms</span>
      <div class="notification mx-2">
        @if (row.fundingId) {
          <a
            [routerLink]="['/fundings', row.fundingId, 'notifications']"
            [queryParams]="{ tab: 'sms', contact: row.contactId, message: row.smsMessageId }"
            (click)="event.next({ type: 'open', data: row })">
            {{ row.fromName || row.fromNumber }}
          </a>
        } @else {
          <span>{{ row.fromName || row.fromNumber }}</span>
        }
        <div class="small text-dark normal-case">{{ preview(row.body) }}</div>
        <div class="small">{{ row.clientName }}</div>
      </div>
      <span class="datetime small">
        <strong>{{ getFormatFromNow(row.receivedAt) }}</strong>
      </span>
      <span class="status new"></span>
    </div>
  } @empty {
    <div class="small p-2 text-center">No new SMS replies.</div>
  }
</div>
